/**
 * Ссылки на только что созданные документы Google. Вкладку после долгой
 * сборки браузер мог заблокировать — адрес остаётся под рукой.
 */
export function GoogleDocsLinks({ urls, labels }: { urls: string[]; labels?: string[] }): JSX.Element | null {
  if (urls.length === 0) return null;
  return (
    <p className="text-sm">
      {urls.length === 1 ? 'Документ готов: ' : 'Документы готовы: '}
      {urls.map((url, i) => (
        <span key={url}>
          {i > 0 && ' · '}
          <a href={url} target="_blank" rel="noreferrer" className="underline">
            {labels?.[i] ?? 'открыть в Google Docs'}
          </a>
        </span>
      ))}
    </p>
  );
}
